__turbopack_context__.v({
  "className": "ivoryll_282437fa-module__wr179G__className",
  "variable": "ivoryll_282437fa-module__wr179G__variable",
});
